function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Icon/Diagrams/Active/Pie");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "hover",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "icon",
  transform: "translate(-538.000000, -84.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icon/Diagrams/Active/Pie",
  transform: "translate(538.000000, 84.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-2-Copy-9",
  stroke: "#2D3C47",
  strokeWidth: 0.5,
  fillOpacity: 0.1,
  fill: "#FFFFFF",
  x: 0.25,
  y: 0.25,
  width: 17.5,
  height: 17.5,
  rx: 1
}), /*#__PURE__*/React.createElement("g", {
  id: "pie-chart-outline",
  transform: "translate(3.600000, 3.600000)",
  fill: "#FFFFFF"
}, /*#__PURE__*/React.createElement("path", {
  d: "M4.78567059,1.01244706 C2.14242353,1.01202353 -0.000211764706,3.15465882 0,5.79790588 C-0.000211764706,8.44136471 2.14242353,10.5842118 4.78567059,10.584 C7.42870588,10.5842118 9.57176471,8.44157647 9.57134118,5.79790588 L4.78567059,5.79790588 L4.78567059,1.01244706 Z",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.81569412,0.0175764706 L5.81569412,4.80345882 L10.6015765,4.80345882 C10.6013647,2.16 8.45894118,0.0171529412 5.81569412,0.0175764706 Z",
  id: "Path"
})), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-2-Copy-9",
  stroke: "#2D3C47",
  strokeWidth: 0.5,
  x: 0.25,
  y: 0.25,
  width: 17.5,
  height: 17.5,
  rx: 1
}))));

var SvgPie = function SvgPie(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPie, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pie.706b083e.svg";
export { ForwardRef as ReactComponent };